var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`custom-input-help-text input-${_vm.size}`,attrs:{"for":_vm.context.id}},[(_vm.requiredHelpTextVisible)?_c('label',{staticClass:"custom-required-help-text"},[_c('span',[_vm._v("* ")]),_vm._v(_vm._s(_vm.$t('global.validation.required')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }